
import axios from '../../functions/axios';
import { useReducer } from 'react';
import { useNavigate } from "react-router-dom";
import  style from'./Driver.module.css';
function AddDriver() {
  const formReducer = (state, event) => {
    if (event.reset) {
      return {
        name: '',
        phoneNumber: '',
      };
    }
    return {
      ...state,
      [event.name]: event.value,
    };
  };

  const [formData, setFormData] = useReducer(formReducer, {});
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    await axios.post(`/driver`, formData);
    navigate('/driversList');
  };

  const handleChange = (event) => {
    setFormData({
      name: event.target.name,
      value: event.target.value,
    });
  };

  return (
    <div className={style.wrapper}>
    <form onSubmit={handleSubmit}>
          <div className={style.section}>
        <h2 className={style.category}>Podaj dane kierowcy</h2>
            <div className={style.row}>
              <label className={style.subcategory} htmlFor='name-data'>
                Imię i nazwisko:
              </label>
              <input type="text" id='name-data' placeholder="podaj imię i nazwisko kierowcy" name='name' onChange={handleChange} value={formData.name || ''} />
            </div>
            <div className={style.row}>
              <label className={style.subcategory} htmlFor='phoneNumber-data'>
                Nr telefonu:
              </label>
              <input type="text" id='phoneNumber-data' placeholder="podaj nr telefonu" name='phoneNumber' onChange={handleChange} value={formData.phoneNumber || ''} />
            </div>
          <hr />
      <span className={style.buttons}>
      <button className='btn btn-default' onClick={navigate.bind(null, '/driversList', { state: { date: formData.day }})}>Anuluj</button>
      <button className='btn btn-default' type='submit'>Dodaj kierowcę</button> 
      </span></div>
    </form>
    </div>
  );
}

export default AddDriver;